// ----------------------------------------------------------------------
// <copyright file="Izenda.PropsComparison.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import { 
  forEach, 
  isFunction, 
  keys, 
  isEqual, 
  isPlainObject, 
  has 
} from "lodash/fp";

export default function compare(nextProps, props) {
  let hasEqual = true;
  forEach(key => {
    if(!has(key, props)) {
      hasEqual = false;
      return false;
    }
    if (!isFunction(nextProps[key])) {
      if (!isEqual(props[key], nextProps[key])) {
        if (isPlainObject(nextProps[key])) {
          hasEqual && (hasEqual = compare(nextProps[key], props[key]));
          if (!hasEqual) return false;
        } else {
          hasEqual = isEqual(props[key], nextProps[key]);
        }
      }
    }

    if (!hasEqual) return false;
  }, keys(nextProps));

  return hasEqual;
}


// WEBPACK FOOTER //
// ./ui/share/utils/Izenda.PropsComparison.js